import { createColumnHelper } from "@tanstack/table-core";
import { formatCurrency, formatDate } from "@tillix/utils/format";
import type { PaymentModel } from "../mobx/core/payment/model.payment";

export const columnHelper = createColumnHelper<PaymentModel>();

export const PaymentColumns = [
  columnHelper.accessor("paidAt", {
    id: "date",
    header: "Date",
    cell: (info) => formatDate(info.getValue()),
  }),
  columnHelper.accessor("confirmationNumber", {
    id: "confirmationNumber",
    header: "Confirmation #",
  }),
  columnHelper.accessor("status", {
    id: "status",
    header: "Status",
    // TODO: if we're goona wrap this text in a badge or something we would do that here
  }),
  columnHelper.accessor("amount", {
    id: "amount",
    header: "Amount",
    cell: (info) => formatCurrency(info.getValue()),
  }),
  columnHelper.accessor("description", {
    id: "description",
    header: "Description",
  }),
  // Discount column commented out — we don't have discount data yet
  // columnHelper.accessor("discount", {
  //   id: "discount",
  //   header: "Discount",
  //   cell: (info) => formatCurrency(info.getValue()),
  // }),
  columnHelper.accessor("fee", {
    id: "fee",
    header: "Fee",
    cell: (info) => formatCurrency(info.getValue()),
  }),
  columnHelper.accessor("serviceAccountId", {
    id: "serviceAccountId",
    header: "Service account",
  }),
  columnHelper.accessor("paymentMethodId", {
    id: "paymentMethodId",
    header: "Payment method",
  }),
];
